import { render } from "./RegistrationQueuePage.vue?vue&type=template&id=32dea11b&scoped=true"
import script from "./RegistrationQueuePage.vue?vue&type=script&lang=js"
export * from "./RegistrationQueuePage.vue?vue&type=script&lang=js"

import "./RegistrationQueuePage.vue?vue&type=style&index=0&id=32dea11b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32dea11b"]])

export default __exports__